/*  ========================================================================
    # Scripts - Overlay Handling
    ========================================================================  */

/**
 * Script that handles overlay logic (variant 7.0).
 */
const OverlayHandling = {
  cfg: {
    overlays: document.querySelectorAll('.c-overlay'),
    overlayTriggers: document.querySelectorAll('a[href^="#overlay-"]'),
    states: {
      open: 'c-overlay--open',
      closed: 'c-overlay--closed'
    },
    overlayOpened: new Event('overlayOpened')
  },

  handleOverlayTriggerClicked(event) {
    const target = event.currentTarget;
    const overlayId = target.getAttribute('href').replace('#', '');
    const overlay = Array.from(this.cfg.overlays).find(o => o.id === overlayId);

    if (overlay) {
      // Toggle the open state of the overlay
      if (overlay.open) {
        this.handleOverlayClose(overlay);
      } else {
        this.handleOverlayOpen(overlay);
      }
    } else {
      console.warn(`Overlay with ID ${overlayId} not found.`);
    }
  },

  handleOverlayClose(overlay) {
    overlay.close();
    overlay.classList.remove(this.cfg.states.open);
    overlay.classList.add(this.cfg.states.closed);
    document.body.style.overflow = 'auto'; // Restore body scroll
  },

  handleOverlayOpen(overlay) {
    overlay.showModal();
    overlay.dispatchEvent(this.cfg.overlayOpened);
  },

  /**
   * Initialize.
   */
  init() {
    if (this.cfg.overlays
      && this.cfg.overlays.length > 0
      && this.cfg.overlayTriggers
      && this.cfg.overlayTriggers.length > 0
    ) {
      this.cfg.overlayTriggers.forEach(trigger => {
        trigger.addEventListener('click', event => {
          event.preventDefault();
          this.handleOverlayTriggerClicked(event);
        });
      });

      this.cfg.overlays.forEach(overlay => {
        // Initial Functions
        overlay.querySelector('.c-overlay__close').addEventListener('click', () => {
          this.handleOverlayClose(overlay);
        });

        const closeButtons = overlay.querySelectorAll('.close-current-overlay');
        closeButtons.forEach(button => {
          button.addEventListener('click', () => {
            this.handleOverlayClose(overlay);
          });
        });

        // Handlers
        // Added custom event to handle if the overlay is opened
        // also used in Products.jsx to trigger animations when overlay is opened
        overlay.addEventListener('overlayOpened', () => {
          overlay.classList.add(this.cfg.states.open);
          overlay.classList.remove(this.cfg.states.closed);
          document.body.style.overflow = 'hidden'; // Hide body scroll
        }, { passive: true });

        overlay.addEventListener('close', () => {
          this.handleOverlayClose(overlay);
        });

        overlay.addEventListener('cancel', () => {
          this.handleOverlayClose(overlay);
        });

        overlay.addEventListener('click', event => {
          if (event.target.classList.value && event.target.classList.value === 'c-overlay__outer') {
            this.handleOverlayClose(overlay);
          }
        });
      });
    }
  }
};

export default OverlayHandling;
